"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUnreadCommunityFavicon = useUnreadCommunityFavicon;
var _react = require("react");
var UNREAD_MESSAGES_ICON_NAME = 'favicon-unread-messages';
var UNREAD_MENTIONS_ICON_NAME = 'favicon-unread-mentions';
var EXTENSION = 'png';
var VERSION_QUERY = 'v=2';
var favicon = document.querySelector('link[rel="icon"]');
var getFaviconFullName = function getFaviconFullName(name) {
  return "".concat(name, ".").concat(EXTENSION, "?").concat(VERSION_QUERY);
};
var getFaviconNameByUnread = function getFaviconNameByUnread(_ref) {
  var unreadMessagesCount = _ref.unreadMessagesCount,
    unreadMentionsCount = _ref.unreadMentionsCount;
  if (unreadMentionsCount) {
    var count = unreadMentionsCount >= 10 ? 10 : unreadMentionsCount;
    return getFaviconFullName("".concat(UNREAD_MENTIONS_ICON_NAME, "-").concat(count));
  }
  if (unreadMessagesCount) {
    return getFaviconFullName(UNREAD_MESSAGES_ICON_NAME);
  }
  return getFaviconFullName('favicon');
};
var faviconUpdate = function faviconUpdate(unreadMentions, unreadMessages) {
  var unreadMentionsCount = unreadMentions === null || unreadMentions === void 0 ? void 0 : unreadMentions.total;
  var BASE_PATH = "".concat(process.env.PUBLIC_URL || '');
  var faviconName = getFaviconNameByUnread({
    unreadMessagesCount: unreadMessages.groupChannels || 0 + unreadMessages.communityChannels || 0,
    unreadMentionsCount: unreadMentionsCount
  });
  var newFaviconHref = "".concat(BASE_PATH, "/").concat(faviconName);
  if (favicon.href !== newFaviconHref) {
    favicon.href = newFaviconHref;
  }
};
function useUnreadCommunityFavicon(_ref2) {
  var unreadMentions = _ref2.unreadMentions,
    unreadMessages = _ref2.unreadMessages;
  (0, _react.useEffect)(function () {
    if (!favicon) {
      return;
    }
    faviconUpdate(unreadMentions, unreadMessages);
  }, [unreadMentions, unreadMessages]);
}